export class TypeOfDisability {
    id : number;
    typeOfDisabilityCode : string;
    typeOfDisabilityName : string;
}